<template>
    <b-nav-item-dropdown text="Tickets"  v-show="isOK == true" left>   
        <b-dropdown-group id="dropdown-group-1" >
            <b-dropdown-item exact to="/home/crearticket">Crear Ticket</b-dropdown-item>
            <b-dropdown-item exact to="/home/consultarticket">Consultar Ticket</b-dropdown-item>            
    
        </b-dropdown-group>
            
           
    </b-nav-item-dropdown>
</template>

<script>
    import {mapState,mapActions} from 'vuex'
    import customMixin from '@/mixins/customMixin'
    export default {
        mixins : [customMixin],
        data: function(){
            return {
                isOK: false
            }
        },
        mounted(){
            this.init()
        },
        computed:{
            ...mapState('login',['rol_id']),
            ...mapState('permiso',['permiso']), 
       
        },
        methods:{
            ...mapActions({
               _fetchPermisos: 'permiso/fetchPermisosUsuarios',
            }),
            init(){
                this._fetchPermisos(this.rol_id).then(() => {  
                    this.isOK =  this.isTickets(this.permiso) 
                })
            },
        }//end methods         
    }
</script>

<style lang="scss" scoped>

</style>